export const getQueryPage = query => +query.page || 1;

export const paginationInit = (perPage, currentPage) => {
	return {
		limit: +perPage,
		skip: +perPage * (+currentPage - 1),
	};
};

export const paginationConfig = (items, perPage, currentPage) => {
	const divider = +items % +perPage;
	return {
		pagination: {
			total: divider === 0 ? +items / +perPage : (+items - divider) / +perPage + 1,
			current: +currentPage,
		},
	};
};
